import type { UpdateTenantOrganizationRequest } from "@repo/shared/types";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getTenantOrganization, updateTenantOrganization } from "@/lib/api/tenant-organization";

const ORGANIZATION_KEY = ["tenantOrganization"] as const;

/** QL-358 — the session tenant's name, address and rename limits (admins only). */
export function useTenantOrganization() {
  const queryClient = useQueryClient();
  const query = useQuery({ queryKey: ORGANIZATION_KEY, queryFn: getTenantOrganization });
  const mutate = () => queryClient.invalidateQueries({ queryKey: ORGANIZATION_KEY });
  return {
    organization: query.data ?? null,
    isLoading: query.isLoading,
    error: query.error,
    mutate,
  };
}

export function useUpdateTenantOrganization() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: UpdateTenantOrganizationRequest) => updateTenantOrganization(payload),
    onSuccess: (data) => {
      queryClient.setQueryData(ORGANIZATION_KEY, data);
      // The tenant name and slug also appear in the bootstrap (navigation) and /me
      queryClient.invalidateQueries({ queryKey: ["app-bootstrap"] });
      queryClient.invalidateQueries({ queryKey: ["me"] });
    },
  });
}
